/**
 * Aperçu d'un fichier — objets d'un bucket et librairies (2026-10-30). Branché dans `fr.ts` sous
 * `filePreview` ; `apercu-fichier.en.ts` porte exactement les mêmes clés.
 */
export const filePreviewFr = {
  open: 'Aperçu de {{name}}',
  loading: 'Lecture du fichier…',
  plainText: 'Texte',
  download: 'Télécharger',
  close: 'Fermer',
  empty: 'Le fichier est vide.',
  truncated: 'Aperçu limité aux premiers {{size}} du fichier : téléchargez-le pour le lire en entier.',
  rowsShown: '{{count}} premières lignes affichées.',
  jsonInvalid: 'Ce n’est pas du JSON valide : le contenu est affiché tel quel.',
  delimiter: 'Séparateur « {{delimiter}} »',
  tab: 'tabulation',
  pdfFrame: 'Aperçu PDF de {{name}}',
  unavailable: {
    title: 'Aperçu indisponible',
    type: 'Ce type de fichier n’a pas d’aperçu. Téléchargez-le pour l’ouvrir.',
    binary: 'Le fichier contient des données binaires : pas d’aperçu en texte.',
    tooLarge:
      'Fichier trop volumineux pour l’aperçu (plus de {{limit}}) : rien n’a été téléchargé. Téléchargez-le pour l’ouvrir.',
    invalid: 'Le contenu ne correspond pas au format annoncé par son nom : aperçu refusé.',
  },
  formats: {
    pdf: 'PDF',
    image: 'Image',
    parquet: 'Parquet',
  },
  parquet: {
    schema: 'Schéma',
    data: 'Premières lignes',
    summary: '{{rows}} lignes · {{columns}} colonnes · {{groups}} groupe(s) de lignes',
    createdBy: 'Écrit par {{tool}}',
    column: 'Colonne',
    type: 'Type',
    nullable: 'Nulle possible',
    yes: 'oui',
    no: 'non',
    codec:
      'Lignes non lues : codec {{codecs}} non pris en charge par l’aperçu (sont lus : SNAPPY, ZSTD et non compressé). Le schéma reste exact.',
    noRows: 'Aucune ligne.',
    partialRead: 'Lu par plages : {{read}} sur {{size}} ({{requests}} requêtes)',
    rowGroupTooLarge:
      'Lignes non lues : les premiers groupes de lignes pèsent {{size}}, au-delà de ce que l’aperçu tire ({{limit}}). Le schéma reste exact ; téléchargez le fichier pour les lignes.',
  },
} as const;
